import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export function ChartSkeleton() {
    return (
        <Card className="force-light-mode bg-white dark:bg-gray-200 text-black border rounded-lg shadow-lg">
            <CardHeader>
                <CardTitle className="text-xl font-semibold text-gray-800">
                    <Skeleton className="h-6 w-40" />
                </CardTitle>
            </CardHeader>
            <CardContent>
                <div className="h-[500px] w-full bg-gray-100 dark:bg-gray-200 rounded-lg py-6 shadow-inner flex items-center justify-center">
                    <Skeleton className="h-[300px] w-[90%] rounded-md" />
                </div>
            </CardContent>
        </Card>
    );
}
